import {Tag} from "../../gen/api";
import {Box} from "@mui/material";
import EditField from "../EditField";
import React from "react";

type Props = {
  data: Tag[],
  levels: number,
  onDelete: (tag: Tag) => void,
  onChange: (tag: Tag, event: React.ChangeEvent<HTMLInputElement>) => void,
  onAddNew: (tag: Tag) => void,
}

export default function Groups({data, levels, onDelete, onChange, onAddNew}: Props) {
  return <>
    {data.map((t: Tag) =>
      <Box sx={{ml: "40px"}}>
        <EditField
          field={t.name}
          onChange={(event) => onChange(t, event)}
          onDelete={() => onDelete(t)}
          onAdd={t.childTags && levels > 0 ? () => onAddNew(t) : undefined}
        />
        {t.childTags && <Groups data={t.childTags} levels={levels - 1}
								onDelete={onDelete} onChange={onChange} onAddNew={onAddNew} />
        }
      </Box>
    )}
  </>;
}